<template>
  <span
    :class="[
      'inline-flex items-center px-2 py-0.5 rounded text-sm font-medium',
      params.text_color,
      params.bg_color
    ]"
  >
    {{ params.label }}
  </span>
</template>

<script>
export default {
  name: "AgGridBadge"
};
</script>
